import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'
import { countNotPayedElements, useOrderModel } from '@entities/order'
import { DiffCheckSwitch } from '@features/diff-check'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffCheck',
  emits: ['toggleDiffCheck'],
  setup(__props, { emit }) {

const orderModel = useOrderModel()


const toggleDiffCheck = () => {
  if (diffCheckDisabledCheck.value) { return }
  emit('toggleDiffCheck')
}

// Блокировка раздельного счета
const diffCheckDisabledCheck = computed(() => {
  return (
    orderModel.orderElements.length > 0 &&
    countNotPayedElements(orderModel.orderElements) < 2
  )
})

return { __sfc: true,orderModel, emit, toggleDiffCheck, diffCheckDisabledCheck, DiffCheckSwitch }
}

})